<template>
  <div id="document-picker-v1-fbxq16">
    <b-form-group id="document-picker-v1-9l4mqe"
      v-if="showType == 'form-builder'"
      :description="properties.description"
      :label="properties.label"
      :style="properties.style"
    >
      <v-select id="document-picker-v1-4f1pbq" v-model="controlValue" :options="[]"></v-select>
    </b-form-group>
    <div id="document-picker-v1-jwh49d" v-if="showType == 'properties'">
      <document-picker-v1-properties id="document-picker-v1-ss8mrw" :formId="formId" />
    </div>
    <b-form-group id="document-picker-v1-4uglox"
      style="font-size: 14px"
      v-if="showType == 'form-submitter' && page == currentPage"
      :description="computedPropertiesForm.description"
      :label="computedPropertiesForm.label"
      :style="properties.style"
      :hidden="computedHidden"
      :state="state"
      :invalid-feedback="errors.join(', ')"
    >
      <v-select id="document-picker-v1-ubqvoj"
        style="font-size: 14px"
        v-model="controlValue"
        :options="formattedFormOptions"
      ></v-select>
    </b-form-group>
    <b-form-group id="document-picker-v1-jwpyqu"
      v-if="showType == 'form-viewer'"
      :label="computedPropertiesForm.label"
    >
    </b-form-group>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState, mapActions } from "vuex";
import formSubmitterServer from "../../../../server/formSubmitter";
import { formatDate } from "../../../../helpers/date";
import DocumentPickerV1Properties from "./DocumentPickerV1Properties.vue";
import { formatUser } from "../../../../helpers/user";

export default {
  name: "DocumentPickerV1",
  components: { DocumentPickerV1Properties },
  props: ["showType", "properties", "form", "id", "results", "formId", "page", "componentsIdSuffix"],
  data() {
    return {
      formOptions: [],
      computedProperties: ["description", "label", "hidden", "excludeDocumentStatusesFromOptions"],
      computedConditions: {}
    };
  },
  async mounted() {
    if (this.showType == "form-viewer" || this.showType == "form-submitter") {
      await this.getFormSubmitsOptions();
      
      if(this.componentsIdSuffix) {
        this.initializeComponentValue({
          controlId: this.id,
          properties: this.properties
        });
      }
    }

    this.computeConditions();
    this.$emit("mount-done");
  },
  methods: {
    ...mapMutations("formSubmitter", ["setFormSubmitterComponentMetadata"]),
    ...mapActions("formSubmitter", ["setFormSubmitterComponentValue", "computeFormSubmitterValue", "initializeComponentValue"]),
    computeConditions() {
      const computedConditions = {};
      for (let index = 0; index < this.computedProperties.length; index++) {
        const property = this.computedProperties[index];
        computedConditions[property] =
          typeof this.properties[property] == "string" &&
          this.properties[property].includes("{{");
      }
      this.computedConditions = computedConditions;
    },
    async getFormSubmitsOptions() {
      let submits = [];
      if (this.properties.formId) {
        submits = await formSubmitterServer.queryForAdvancedFormBuilderComponent(
          this.properties.formId,
          this.client.id,
          this.client.episodeOfCare.id
        );
        
        if (
          this.properties.excludeDocumentStatusesFromOptions && 
          this.properties.excludeDocumentStatusesFromOptions.length > 0
        ) {
          submits = submits
          .filter(
            doc => !this.properties
              .excludeDocumentStatusesFromOptions
              .some(statusToExclude => statusToExclude === doc.status)
          );
        }
        
      }

      this.formOptions = submits.map(submit => ({
        value: submit.id,
        text: `${formatDate(this.properties.showEffectiveDate ? submit.effectiveDate : submit.createdAt)} by ${
          submit.createdBy ? formatUser(submit.createdBy) : "-"
        }`
      }));
      this.setFormSubmitterComponentMetadata({
        controlId: this.id,
        controlMetadata: {
          Options: this.formOptions
        }
      });
    },
    getComponentComputedProperties(property) {
      return this.computedPropertiesForm
        ? this.computedPropertiesForm[property] != null
          ? this.computedPropertiesForm[property]
          : this.properties[property]
          ? this.properties[property]
          : ""
        : this.properties[property]
        ? this.properties[property]
        : "";
    },
    getBakedLayout() {
      const hidden = this.getComponentComputedProperties(
        "hidden"
      );

      if(hidden === true || this.properties.hideOnView)
        return "";
        
      return `
      <fieldset aria-describedby="" class="form-group">
        <legend style="font-size: 14px" tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">${this.getComponentComputedProperties(
          "label"
        )}</legend>
        <div style="font-size: 14px" tabindex="-1" role="group" class="bv-no-focus-ring">
        ${this.controlValue ? this.controlValue.label : ""}
        </div>
      </fieldset>`;
    }
  },
  computed: {
    ...mapState("formSubmitter", {
      client: state => state.form.client,
      formErrors: state => state.form.errors,
      currentPage: state => state.form.currentPage
    }),
    ...mapGetters("formSubmitter", [
      "getFormSubmitterComponentValue"
    ]),
    computedPropertiesForm() {
      return this.$store.state.formSubmitter.form.computedProperties[this.id] ?? this.properties;
    },
    controlValue: {
      get() {
        let value = null;
        if (this.results) value = JSON.stringify(this.results[this.id]);
        else
          value = JSON.stringify(this.getFormSubmitterComponentValue(this.id));
        const valueObj = this.formattedFormOptions.find(opt => {
          if (value && opt.value) {
            return JSON.parse(value).id == opt.value;
          }
          return false;
        });
        return valueObj;
      },
      async set(newControlValue) {
        let filteredControlValue = {};
        if (newControlValue && this.controlValue != newControlValue.value) {
          const parsedControlValue = await formSubmitterServer.getForAdvancedFormControl(newControlValue.value); 
          filteredControlValue = {
            id: parsedControlValue.id,
            status: parsedControlValue.status,
            versionId: parsedControlValue.versionId,
            createdAt: parsedControlValue.createdAt,
            createdBy: {
              id: parsedControlValue.createdBy?.id,
              fullName: parsedControlValue.createdBy ? this.formatUser(parsedControlValue.createdBy) : "",
              credentials: parsedControlValue.createdBy?.credentials
            },
            mode: parsedControlValue.mode,
            results: parsedControlValue.results,
            score: parsedControlValue.score,
            effectiveDate: parsedControlValue.effectiveDate
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: filteredControlValue,
            userAction: true,
            hardSet: true
          });
          this.$emit("update-child-control-value", {
            controlId: this.id,
            controlValue: filteredControlValue
          });
        }else{
          filteredControlValue = {
            id: null,
            status: null,
            versionId: null,
            createdAt: null,
            createdBy: {
              id: null,
              fullName: null,
              credentials: null
            },
            mode: null,
            results: {},
            score: null,
            effectiveDate: null
          };
          this.setFormSubmitterComponentValue({
            controlId: this.id,
            controlValue: filteredControlValue,
            userAction: true,
            hardSet: true
          });
        }
        if (this.properties.onChange) {
            this.computeFormSubmitterValue({
              elementId: this.id,
              property: "onChange",
              value: `computed:(${this.properties.onChange})(${JSON.stringify(
                filteredControlValue
              )})`,
              defaultValue: null,
              form: this.form,
              statements: true
            });
          }
      }
    },
    formattedFormOptions() {
      return this.formOptions.map(opt => ({
        value: opt.value,
        label: opt.text
      }));
    },
    errors: {
      get() {
        return this.formErrors[this.id] ? this.formErrors[this.id] : [];
      }
    },
    state: {
      get() {
        return this.errors.length == 0 ? null : false;
      }
    },
    computedHidden() {
      const hiddenValue = this.computedConditions.hidden
        ? this.computedPropertiesForm.hidden
        : this.properties.hidden

      this.$emit("change-hidden-property", hiddenValue);
      return hiddenValue;
    }
  }
};
</script>
